<template>
    <div class="close-alert px-3 py-2 d-inline-block w-100" v-if="showRestTime">
        <template v-if="showText === 'alert_timer'">
            <span>この相談は、あと</span>
            <span class="close-alert-red">{{ restTimeLabel }}</span>
            <span>で終了します。<wbr>延長が必要な場合は、<wbr>あらためて予約をお願いいたします。</span>
        </template>
        <template v-else-if="showText === 'alert_fuzzy_time'">
            <span>相談終了時間が近づいています。終了準備をしてください。</span>
        </template>
        <template v-else>
            <span>相談を終了しています。</span>
        </template>
    </div>
</template>

<script>
import constants from '../../constants'
import YokumiruHelper from '../../YokumiruHelper'
import moment from 'moment-timezone'

export default {
        props: {
            consultation: {
                type: Object,
                default: null,
            },
            timezone: {
                type: String,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                current: null,
                end_before: null,
                end: null,
                diff_start: 0,
                countdown: this.$store.state.configs.consultation_end_time_count * 1000,
                interval: null,
                fuzzy_time: this.$store.state.configs.consultation_fuzzy_time * 1000,
            }
        },

        created: function () {
            this.init()

            this.interval = setInterval(() => {
                this.current = YokumiruHelper.jstTimeNow()
            }, 1000)
        },

        beforeDestroy: function () {
            if (this.interval) {
                clearInterval(this.interval)
            }
        },

        methods: {
            init() {
                moment.locale('ja')

                this.current = YokumiruHelper.jstTimeNow()
                this.end_before = moment.tz(this.consultation.end_time, 'Asia/Tokyo')
                this.end = this.end_before.clone().add(this.fuzzy_time / 1000, 'seconds')
                
                if (this.consultation.start_time < this.consultation.started_at) {
                    this.started_at = moment.tz(this.consultation.started_at, 'Asia/Tokyo')
                    this.start_time = moment.tz(this.consultation.start_time, 'Asia/Tokyo')
                    this.diff_start = Math.floor(this.started_at.diff(this.start_time, 'seconds', true))
                    this.end = this.end.add(this.diff_start, 'seconds')
                }
            }
        },

        computed: {
            restTime() {
                if (!this.current || !this.end_before) return 0
                return this.end_before.diff(this.current)
            },
            restFuzzyTime() {
                if (!this.current || !this.end) return 0
                return this.end.diff(this.current)
            },
            restTimeLabel() {
                return YokumiruHelper.millisToMinutesAndSeconds(this.restTime)
            },
            showRestTime() {
                if (this.consultation.status !== constants.consultations.hold) {
                    return false
                }
                if (this.current && this.end_before) {
                    const threshold = this.end_before.clone().subtract(this.countdown / 1000, 'seconds')
                    if (this.current.isSameOrAfter(threshold)) {
                        return true
                    }
                }
                return false
            },
            showText() {
                if (this.restTime > 0) {
                    return 'alert_timer'
                }
                else if (this.restFuzzyTime > 0) {
                    return 'alert_fuzzy_time'
                }
                else {
                    return 'alert_end_consul'
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.close-alert {
    color: #806829;
    background-color: #FDF3D1;
    margin-bottom: 10px;
}

.close-alert-red {
    color: #FF0000;
    font-weight: bold;
    width: 2.3em;
    font-size: 15px;
}
</style>
